












































































































































































































































































































































export default function (Component) {
  Component.options.__source = "node_modules/element-ui/packages/image/src/image-viewer.vue"
}
